import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const userAth=()=>{
  let user = JSON.parse(localStorage.getItem("user"))
  return (user != null)?true:false
}

const ProtectedRoutes=(props) =>{
  const auth=userAth()
  return auth?<Outlet/>:<Navigate to="/login"/>
}

export default ProtectedRoutes;